/**APIの基本レスポンス */
export type APIResponse<T> = {
  code: number;
  message: string;
  errors: Array<{ [key: string]: Array<string> }>;
  result: T;
};

/**ページネーション時のresult */
export type APIResponseResultPagination<T> = {
  currentPage: number;
  lastPage: number;
  total: number;
  perPage: number;
  data: Array<T>;
};

export type { LotteryDrawResultWChance } from '@monorepo/common';

export { ItemType } from '@monorepo/common';

/* 言語 */
export const Locales = {
  ja: { value: 'ja', text: '日本語' },
  en: { value: 'en', text: 'English' },
} as const;
export type LocalesType = keyof typeof Locales;

// GA4イベントパラメータの型定義
export type GA4EventParams = {
  category?: string;
  label?: string;
  engagement_value?: number;
  callback_url?: string;
  page_location?: string;
  page_title?: string;
  source?: string;
  lottery_id?: number;
  shop_name?: string;
  value?: number;
  transaction_id?: number;
  user_id?: number;
};
